(() => {
  const loader = document.currentScript;
  const pageType = loader?.dataset.adwoaPageType || '';
  if (pageType === 'password') return;

  const pathname = (() => {
    const path = window.location.pathname || '/';
    return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
  })();

  const isProduct = pageType === 'product' || pathname.indexOf('/products/') === 0;
  const isSearch = pageType === 'search' || pathname === '/search';
  const hasGridContainer = () => Boolean(document.getElementById('ProductGridContainer'));
  const isCollection = pageType === 'collection' || pathname.indexOf('/collections/') === 0 || hasGridContainer();
  const useMainlineTopline = isCollection || isProduct || isSearch;

  const styleId = 'AdwoaGlobalInterfaceStyles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      :root {
        --adwoa-title-font: "Times New Roman", Times, serif;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      .h0,
      .h1,
      .h2,
      .h3,
      .h4,
      .h5,
      .title,
      .main-page-title,
      .collection-hero__title,
      .product__title,
      .product__title > *,
      .card__heading {
        font-family: var(--adwoa-title-font) !important;
      }

      .adwoa-shop-interface { display: none; }

      @media screen and (min-width: 990px) {
        html.adwoa-shop-interface-active .desktop-header { display: none !important; }

        .adwoa-shop-interface {
          position: fixed;
          top: 0;
          right: 0;
          left: 0;
          z-index: 2147481500;
          display: block;
          height: 88px;
          color: #000;
          pointer-events: none;
          font-family: "Times New Roman", Times, serif;
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: 1;
          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .adwoa-shop-interface a,
        .adwoa-shop-interface button,
        .adwoa-shop-interface input {
          color: #000;
          font: inherit;
          letter-spacing: inherit;
          text-transform: inherit;
          text-decoration: none;
        }

        .adwoa-shop-interface button {
          -webkit-appearance: none;
          appearance: none;
          border: 0;
          margin: 0;
          padding: 0;
          background: transparent;
          cursor: pointer;
        }

        .adwoa-shop-interface__primary {
          position: absolute;
          top: 27px;
          right: 30px;
          left: 30px;
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          pointer-events: none;
        }

        .adwoa-shop-interface__primary > * { pointer-events: auto; }

        .adwoa-shop-interface__left,
        .adwoa-shop-interface__utilities {
          display: flex;
          align-items: baseline;
        }

        .adwoa-shop-interface__left { gap: 18px; }
        .adwoa-shop-interface__utilities { gap: 27px; }

        .adwoa-shop-menu { position: relative; display: inline-block; }
        .adwoa-shop-menu__trigger { position: relative; display: inline-block; padding-bottom: 7px; }

        .adwoa-shop-menu__trigger::after,
        .adwoa-shop-interface__utility::after,
        .adwoa-shop-filter::after {
          content: '';
          position: absolute;
          right: 50%;
          bottom: 2px;
          left: 50%;
          height: 1px;
          background: currentColor;
          transition: left 180ms ease, right 180ms ease;
        }

        .adwoa-shop-menu:hover .adwoa-shop-menu__trigger::after,
        .adwoa-shop-menu:focus-within .adwoa-shop-menu__trigger::after,
        .adwoa-shop-interface__utility:hover::after,
        .adwoa-shop-interface__utility:focus-visible::after,
        .adwoa-shop-filter:hover::after,
        .adwoa-shop-filter:focus-visible::after {
          right: 0;
          left: 0;
        }

        .adwoa-shop-menu__dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 9px;
          min-width: 145px;
          padding: 9px 0 6px;
          background: #fff;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-5px);
          pointer-events: none;
          transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
        }

        .adwoa-shop-menu:hover .adwoa-shop-menu__dropdown,
        .adwoa-shop-menu:focus-within .adwoa-shop-menu__dropdown {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
          pointer-events: auto;
        }

        .adwoa-shop-menu__dropdown a {
          position: relative;
          display: inline-block;
          padding: 2px 0 4px;
          white-space: nowrap;
        }

        .adwoa-shop-menu__dropdown a::after {
          content: '';
          position: absolute;
          right: 50%;
          bottom: 0;
          left: 50%;
          height: 1px;
          background: currentColor;
          transition: left 180ms ease, right 180ms ease;
        }

        .adwoa-shop-menu__dropdown a:hover::after,
        .adwoa-shop-menu__dropdown a:focus-visible::after,
        .adwoa-shop-menu__dropdown a.is-active::after {
          right: 0;
          left: 0;
        }

        .adwoa-shop-interface__utility,
        .adwoa-shop-filter {
          position: relative;
          display: inline-block;
          padding-bottom: 7px;
          white-space: nowrap;
        }

        .adwoa-shop-view {
          display: inline-flex;
          align-items: baseline;
          gap: 6px;
          line-height: 1;
          letter-spacing: .015em;
          white-space: nowrap;
        }

        .adwoa-shop-view__label {
          margin-right: 0;
          opacity: 1;
        }

        .adwoa-shop-view button {
          position: relative;
          min-width: auto;
          padding: 0 0 5px;
          line-height: 1;
          text-align: center;
          opacity: .5;
          transition: opacity 160ms ease;
        }

        .adwoa-shop-view button.is-active {
          opacity: 1;
        }

        .adwoa-shop-view button::after {
          content: '';
          position: absolute;
          right: 50%;
          bottom: 0;
          left: 50%;
          height: 1px;
          background: currentColor;
          transition: left 160ms ease, right 160ms ease;
        }

        .adwoa-shop-view button:hover::after,
        .adwoa-shop-view button:focus-visible::after,
        .adwoa-shop-view button.is-active::after {
          right: 0;
          left: 0;
        }

        .adwoa-shop-interface a:focus-visible,
        .adwoa-shop-interface button:focus-visible,
        .adwoa-shop-interface input:focus-visible {
          outline: 1px solid #000;
          outline-offset: 4px;
          box-shadow: none;
        }

        .product-grid-container {
          padding-top: 36px;
        }

        .product-grid-container #product-grid.adwoa-view-2 > .grid__item {
          flex: 0 0 calc((100% - 8px) / 2) !important;
          width: calc((100% - 8px) / 2) !important;
          max-width: calc((100% - 8px) / 2) !important;
        }

        .product-grid-container #product-grid.adwoa-view-3 > .grid__item {
          flex: 0 0 calc((100% - 16px) / 3) !important;
          width: calc((100% - 16px) / 3) !important;
          max-width: calc((100% - 16px) / 3) !important;
        }

        .product-grid-container #product-grid.adwoa-view-4 > .grid__item {
          flex: 0 0 calc((100% - 24px) / 4) !important;
          width: calc((100% - 24px) / 4) !important;
          max-width: calc((100% - 24px) / 4) !important;
        }

        .product-grid-container #product-grid.adwoa-view-grid > .grid__item {
          flex: 0 0 calc((100% - 40px) / 6) !important;
          width: calc((100% - 40px) / 6) !important;
          max-width: calc((100% - 40px) / 6) !important;
        }

        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-interface__primary,
        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-interface__left,
        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-interface__utilities,
        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-search {
          align-items: baseline !important;
        }

        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-search {
          top: auto !important;
          display: inline-block !important;
          height: auto !important;
          min-height: 0 !important;
          margin-top: 0 !important;
          padding-top: 0 !important;
          padding-bottom: 7px !important;
          line-height: 1 !important;
          vertical-align: baseline !important;
          transform: none !important;
        }

        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-search:not(.is-open) .adwoa-shop-search__trigger {
          display: inline-block !important;
        }

        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-search:not(.is-open) .adwoa-shop-search__form {
          display: none !important;
        }

        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-search.is-open .adwoa-shop-search__trigger {
          display: none !important;
        }

        html.adwoa-product-page-active body.template-product [data-adwoa-shop-interface] .adwoa-shop-search.is-open .adwoa-shop-search__form {
          display: inline-flex !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const activateExistingInterface = () => {
    const existing = document.querySelector('[data-adwoa-shop-interface]');
    if (!existing) return false;
    document.documentElement.classList.add('adwoa-shop-interface-active');
    return true;
  };

  if (activateExistingInterface()) return;

  const cartCountFromHeader = () => {
    const cartLinks = Array.from(document.querySelectorAll('#cart-icon-bubble'));
    for (const link of cartLinks) {
      const match = link.textContent.match(/\[(\d+)\]/);
      if (match) return match[1];
    }
    return '0';
  };

  const activeAttributes = (path) => pathname === path ? ' class="is-active" aria-current="page"' : '';

  const viewMarkup = useMainlineTopline ? `
    <div class="adwoa-shop-view" role="group" aria-label="Product display">
      <span class="adwoa-shop-view__label">VIEW:</span>
      <button type="button" data-adwoa-view="2" aria-label="Show 2 products per row">2</button>
      <button type="button" data-adwoa-view="3" aria-label="Show 3 products per row">3</button>
      <button type="button" data-adwoa-view="4" aria-label="Show 4 products per row">4</button>
      <button type="button" data-adwoa-view="grid" aria-label="Show 6 products per row">GRID</button>
    </div>
  ` : '';

  const filterMarkup = useMainlineTopline ? `
    <button type="button" class="adwoa-shop-filter" data-adwoa-filter>FILTER</button>
  ` : '';

  const shopInterface = document.createElement('div');
  shopInterface.className = 'adwoa-shop-interface adwoa-shop-interface--global';
  shopInterface.setAttribute('data-adwoa-shop-interface', '');
  shopInterface.dataset.adwoaHeaderSource = 'mainline-topline';
  shopInterface.innerHTML = `
    <div class="adwoa-shop-interface__primary">
      <div class="adwoa-shop-interface__left">
        <div class="adwoa-shop-menu">
          <a class="adwoa-shop-menu__trigger" href="/collections/all" aria-haspopup="true">SHOP</a>
          <div class="adwoa-shop-menu__dropdown" aria-label="Shop collections">
            <a href="/collections/mainline"${activeAttributes('/collections/mainline')}>MAINLINE</a>
            <a href="/collections/philosophy"${activeAttributes('/collections/philosophy')}>PHILOSOPHY</a>
            <a href="/collections/all"${activeAttributes('/collections/all')}>ALL</a>
          </div>
        </div>
        ${filterMarkup}
        ${viewMarkup}
      </div>

      <div class="adwoa-shop-interface__utilities">
        ${isProduct ? '' : '<a class="adwoa-shop-interface__utility" href="/search">SEARCH</a>'}
        <a class="adwoa-shop-interface__utility" href="/pages/appointment">SHOWROOM</a>
        <a class="adwoa-shop-interface__utility" href="/cart" data-adwoa-bag>BAG (${cartCountFromHeader()})</a>
      </div>
    </div>
  `;

  document.body.appendChild(shopInterface);
  document.documentElement.classList.add('adwoa-shop-interface-active');

  const bagLink = shopInterface.querySelector('[data-adwoa-bag]');
  if (bagLink) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (cart && Number.isFinite(cart.item_count)) bagLink.textContent = `BAG (${cart.item_count})`;
      })
      .catch(() => {});
  }

  if (!useMainlineTopline) return;

  const storageKey = 'adwoa-product-grid-view';
  const viewClasses = ['adwoa-view-2', 'adwoa-view-3', 'adwoa-view-4', 'adwoa-view-grid'];
  let selectedView = '3';

  try {
    const savedView = window.localStorage.getItem(storageKey);
    if (['2', '3', '4', 'grid'].includes(savedView)) selectedView = savedView;
  } catch (error) {}

  const syncButtons = () => {
    shopInterface.querySelectorAll('[data-adwoa-view]').forEach((button) => {
      const active = button.dataset.adwoaView === selectedView;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const applyView = () => {
    const grid = document.querySelector('#ProductGridContainer #product-grid');
    syncButtons();
    if (!grid) return false;

    grid.classList.remove(...viewClasses);
    grid.classList.add(`adwoa-view-${selectedView}`);
    return true;
  };

  shopInterface.querySelectorAll('[data-adwoa-view]').forEach((button) => {
    button.addEventListener('click', () => {
      selectedView = button.dataset.adwoaView;
      try { window.localStorage.setItem(storageKey, selectedView); } catch (error) {}
      applyView();
    });
  });

  shopInterface.querySelector('[data-adwoa-filter]')?.addEventListener('click', (event) => {
    event.preventDefault();
    const nativeFilter = document.querySelector('#main-collection-filters .mobile-facets__open');
    if (nativeFilter) nativeFilter.click();
  });

  const attachGridObserver = () => {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer || gridContainer.dataset.adwoaViewObserver === 'true') return false;

    gridContainer.dataset.adwoaViewObserver = 'true';
    const observer = new MutationObserver(() => requestAnimationFrame(applyView));
    observer.observe(gridContainer, { childList: true, subtree: true });
    applyView();
    return true;
  };

  applyView();
  attachGridObserver();

  let attempts = 0;
  const retry = window.setInterval(() => {
    attempts += 1;
    const applied = applyView();
    const attached = attachGridObserver();
    if ((applied && attached) || attempts > 120) window.clearInterval(retry);
  }, 100);
})();
